function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.612 2.388a.964.964 0 00-1.364 0l-6.35 6.35v1.364h1.364l6.35-6.35a.964.964 0 000-1.364zm-2.145-.782a2.07 2.07 0 112.927 2.927L7.88 11.046a.553.553 0 01-.39.161H5.345a.553.553 0 01-.552-.552V8.509c0-.146.058-.287.161-.39l6.513-6.513zM3.07 3.622a.964.964 0 00-.965.965v8.343c0 .533.432.965.965.965h8.343a.964.964 0 00.965-.965V9.138a.553.553 0 111.105 0v3.792a2.07 2.07 0 01-2.07 2.07H3.07A2.07 2.07 0 011 12.93V4.587a2.07 2.07 0 012.07-2.07h3.792a.553.553 0 110 1.105H3.07z",
  fill: "#2D2D2D"
});
function SvgLapizparaeditar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Lapiz para editar.svg";
export { SvgLapizparaeditar as ReactComponent };